export const environment = {
  production: false,
  apiBaseUrl: 'https://mm.futureplan.cloud/api/v1'
};
